/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_DescriptionInputs */

const en_admin_subscriptions_description = /** @type {(inputs: Admin_Subscriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all subscriptions`)
};

const zh_admin_subscriptions_description = /** @type {(inputs: Admin_Subscriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看所有订阅`)
};

/**
* | output |
* | --- |
* | "View all subscriptions" |
*
* @param {Admin_Subscriptions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_description = /** @type {((inputs?: Admin_Subscriptions_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_description(inputs)
	return zh_admin_subscriptions_description(inputs)
});
export { admin_subscriptions_description as "admin.subscriptions.description" }